
import * as z from "zod";

// Type for users fetched from database
export interface StrategyProviderUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
}

// Form schema for validation
export const existingUserSchema = z.object({
  assignmentType: z.literal('existing'),
  id: z.string().uuid("Please select a valid user")
});

export const newUserSchema = z.object({
  assignmentType: z.literal('new'),
  email: z.string().email("Please enter a valid email address"),
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  password: z.string().min(8, "Password must be at least 8 characters")
});

export const userAssignmentSchema = z.discriminatedUnion('assignmentType', [
  existingUserSchema,
  newUserSchema
]);

export type UserAssignmentFormValues = z.infer<typeof userAssignmentSchema>;
